import { useState, useEffect, useCallback } from "react";
import { fetchDataWithRetries } from "../../Component/function/FunctionApi";
import Sidebar from "../../Component/Sidebar/Sidebar";
import Header from "../../Component/Header/Header";

function StatisticsSection() {
  const [stats, setStats] = useState(null);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    Date: "",
    Month: "",
    Year: "",
    From: "",
    To: "",
  });

  const buildQueryString = (f) => {
    const params = new URLSearchParams();
    if (f.Date)  params.append("Date",  f.Date);
    if (f.Month) params.append("Month", f.Month);
    if (f.Year)  params.append("Year",  f.Year);
    if (f.From)  params.append("From",  f.From);
    if (f.To)    params.append("To",    f.To);
    return params.toString() ? `Statistics?${params.toString()}` : "Statistics";
  };

  const fetchStats = useCallback(() => {
    setLoading(true);
    fetchDataWithRetries(buildQueryString(filters), setStats, setStatus);
    setLoading(false);
  }, [filters]);

  useEffect(() => {
    fetchStats();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleClear = () => {
    setFilters({ Date: "", Month: "", Year: "", From: "", To: "" });
  };

  const data = stats?.data;

  return (
    <div className="apDiv">
      <Sidebar />
      <div className="body_container container" dir="rtl">
        <div className="Header">
          <Header isSearch="false" title="الإحصائيات" />
        </div>

        <div className="statistics-section">

          {/* ── فلاتر ── */}
          <div className="stats-filters-card">
            <p className="filters-label">فلترة الإحصائيات</p>
            <div className="filters-grid">

              <div className="filter-group">
                <label>يوم محدد</label>
                <input type="date" name="Date" value={filters.Date} onChange={handleChange} />
              </div>

              <div className="filter-group">
                <label>الشهر</label>
                <select name="Month" value={filters.Month} onChange={handleChange}>
                  <option value="">اختر الشهر</option>
                  {["يناير","فبراير","مارس","أبريل","مايو","يونيو",
                    "يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"]
                    .map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
                </select>
              </div>

              <div className="filter-group">
                <label>السنة</label>
                <select name="Year" value={filters.Year} onChange={handleChange}>
                  <option value="">اختر السنة</option>
                  {[2026, 2025, 2024].map((y) => <option key={y} value={y}>{y}</option>)}
                </select>
              </div>

              <div className="filter-group">
                <label>من</label>
                <input type="date" name="From" value={filters.From} onChange={handleChange} />
              </div>

              <div className="filter-group">
                <label>إلى</label>
                <input type="date" name="To" value={filters.To} onChange={handleChange} />
              </div>

              <div className="filter-actions">
                <button className="btn-search" onClick={fetchStats} disabled={loading}>
                  {loading ? "..." : "بحث"}
                </button>
                <button className="btn-clear" onClick={handleClear}>مسح</button>
              </div>

            </div>
          </div>

          {/* ── كروت الأرقام ── */}
          {data && (
            <>
              <div className="stats-cards-grid">
                <StatCard label="إجمالي الفواتير"  value={data.totalInvoices} />
                <StatCard label="إجمالي الإيرادات" value={data.totalRevenue?.toLocaleString()} />
                <StatCard label="جديدة"             value={data.newCount} />
                <StatCard
                  label="مُسلَّمة"
                  value={`${data.deliveredCount}`}
                  sub={`${data.deliveredPercentage}%`}
                  color="success"
                />
                <StatCard
                  label="مُرتجعة"
                  value={`${data.returnedCount}`}
                  sub={`${data.returnedPercentage}%`}
                  color="warning"
                />
                <StatCard
                  label="مُلغاة"
                  value={`${data.cancelledCount}`}
                  sub={`${data.cancelledPercentage}%`}
                  color="danger"
                />
                <StatCard
                  label="تحت النجهيز"
                  value={`${data.inProgressCount}`}
                  sub={`${data.inProgressPercentage}%`}
                  color="danger"
                />
              </div>

         </>
          )}

          {!data && !loading && (
            <p style={{ textAlign: "center", color: "#888", marginTop: "1rem" }}>
              اختر فلتر واضغط بحث لعرض الإحصائيات
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

function StatCard({ label, value, sub, color }) {
  return (
    <div className="stat-card">
      <p className="stat-label">{label}</p>
      <p className={`stat-value ${color ? `stat-${color}` : ""}`}>
        {value}
        {sub && <span className="stat-sub"> — {sub}</span>}
      </p>
    </div>
  );
}

function DetailRow({ label, value }) {
  return (
    <div className="detail-row">
      <span className="detail-label">{label}</span>
      <span className="detail-value">{value}</span>
    </div>
  );
}

export default StatisticsSection;